module.exports = __webpack_public_path__ + "static/src/content/images/graff.411ebe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/graff.png
// module id = Ow+V
// module chunks = 0